import * as types from './types';

const INITIAL_STATE = {
  loading: false,
  error: null,
  fiscalYears: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GET_FISCAL_YEARS_LOADING:
      return { ...state, loading: payload };
    case types.GET_FISCAL_YEARS:
      return { ...state, fiscalYears: payload.data };
    case types.GET_FISCAL_YEARS_ERROR:
      return { ...state, getFiscalYearsError: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/fiscalYears/reducer.js